import axios from "axios";
import { gfsBaseURL } from "src/HostName";

const addAgentFareInstance = axios.create({
  baseURL: gfsBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// dropdown
export const getcarrierDropdownApi = async (id) => {
  const response = await addAgentFareInstance.get(`gfs-rule/dropdown?id=${id}`);
  return response;
};

// location
export const getLocations = async () => {
  const response = await addAgentFareInstance.get(`gfs-rule/location`);
  return response;
};

export const addLocationGroup = async (data) => {
  const response = await addAgentFareInstance.post(`gfs-rule/location`, data);
  return response;
};

export const editLocation = async (id, data) => {
  const response = await addAgentFareInstance.put(
    `gfs-rule/location?id=${id}`,
    data
  );
  return response;
};

// carrier
export const addCarrierGroup = async (data) => {
  const response = await addAgentFareInstance.post(`gfs-rule/carrier`, data);
  return response;
};

export const getCarriers = async () => {
  const response = await addAgentFareInstance.get(`gfs-rule/carrier`);
  return response;
};

export const editCarrier = async (id, data) => {
  const response = await addAgentFareInstance.put(
    `gfs-rule/carrier?id=${id}`,
    data
  );
  return response;
};

// fee rule
export const getFeeRule = async () => {
  const response = await addAgentFareInstance.get(`gfs-rule/feeRule`);
  return response;
};

export const addFeeRule = async (data) => {
  const response = await addAgentFareInstance.post(`gfs-rule/feeRule`, data);
  return response;
};

export const editFeeRule = async (id, data) => {
  const response = await addAgentFareInstance.put(
    `gfs-rule/feeRule?id=${id}`,
    data
  );
  return response;
};

export const deleteFeeRule = async (id) => {
  const response = await addAgentFareInstance.delete(
    `gfs-rule/feeRule?id=${id}`
  );
  return response;
};

export const downloadFile = async () => {
  const response = await addAgentFareInstance.get(`gfs-rule/getFile`, {
    responseType: "blob", // 👈 IMPORTANT
  });
  //    console.log("response", response);
  // Create download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;

  // Try to get filename from headers, fallback if needed
  const contentDisposition = response.headers["content-disposition"];
  let fileName = "FinalAllTravomint.xml"; // default fallback

  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
    if (fileNameMatch?.length > 1) {
      fileName = fileNameMatch[1];
    }
  }

  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return response;
};

export const addRuleIn = async () => {
  const response = await addAgentFareInstance.get(`gfs-rule/addRuleInCRM`);
  return response;
};
